export enum CuppingSessionStatus {
  InProgress = 1,
  Done = 2,
  Deleted = 3,
}

export const CuppingSessionStatusString = {
  [CuppingSessionStatus.InProgress]: 'In progress',
  [CuppingSessionStatus.Done]: 'Done',
  [CuppingSessionStatus.Deleted]: 'Deleted',
}
